import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import {
  getUserProfiles,
  getUserProfilesSuccess,
  getUserProfilesFailure,
} from '../actions/ProfileList';
import {
  restoreLogin,
  restoreLoginSuccess,
  restoreLoginFailure,
} from '../actions/RestoreLogin';
import { login, loginSuccess, loginFailure, loginIdle } from '../actions/Login';

const getUserProfilesStatus = handleActions(
  {
    [getUserProfiles]: () => {
      return 'LOADING';
    },
    [getUserProfilesSuccess]: () => {
      return 'SUCCESS';
    },
    [getUserProfilesFailure]: () => {
      return 'FAILURE';
    },
  },
  'IDLE'
);
const restoreLoginStatus = handleActions(
  {
    [restoreLogin]: () => {
      return 'LOADING';
    },
    [restoreLoginSuccess]: () => {
      return 'SUCCESS';
    },
    [restoreLoginFailure]: () => {
      return 'FAILURE';
    },
  },
  'IDLE'
);

const loginStatus = handleActions(
  {
    [login]: () => {
      return { loading: true, message: 'LOADING' };
    },
    [loginSuccess]: () => {
      return { loading: false, message: 'SUCCESS' };
    },
    [loginFailure]: (state, action) => {
      return {
        loading: false,
        message: 'FAILURE',
        errorMsg:
          action.payload && action.payload.response
            ? action.payload.response.data.message
            : '',
      };
    },
    [loginIdle]: () => {
      return { message: 'IDLE' };
    },
    [restoreLogin]: () => {
      return { message: 'LOADING' };
    },
    [restoreLoginSuccess]: () => {
      return { message: 'SUCCESS' };
    },
    [restoreLoginFailure]: () => {
      return { message: 'FAILURE' };
    },
  },
  {
    message: 'IDLE',
    errorMsg: '',
    loading: false,
  }
);

const status = combineReducers({
  getUserProfilesStatus,
  restoreLoginStatus,
  loginStatus,
});
export { status };
